import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
  const header = document.querySelector('.header');
  const menuButton = document.querySelector('.menu-icon');
  const menu = document.getElementById('main-menu');

  if (header) {
    let isTicking = false;

    const updateHeaderScrollState = () => {
      header.classList.toggle('header--scrolled', window.scrollY > 0);
      isTicking = false;
    };

    const requestHeaderScrollStateUpdate = () => {
      if (isTicking) return;

      isTicking = true;
      window.requestAnimationFrame(updateHeaderScrollState);
    };

    updateHeaderScrollState();
    window.addEventListener('scroll', requestHeaderScrollStateUpdate, {
      passive: true,
    });
    window.addEventListener('resize', requestHeaderScrollStateUpdate);
  }

  if (!menuButton || !menu) return;

  menuButton.addEventListener('click', () => {
    menuButton.classList.toggle('is-active');
    menu.classList.toggle('is-active');
  });

  mobileMenuHandler();

  /**
   * Mobile Burger menu
   */
  function mobileMenuHandler() {
    const $headerMenu = $('.header-menu');
    const $menuItems = $headerMenu.find('li.menu-item-has-children');
    const $burgerBtn = $('.menu-icon');

    $menuItems.each(function () {
      if (!$(this).children('.dropdown-toggle').length) {
        $(this).append('<div class="dropdown-toggle"></div>');
      }
    });

    $headerMenu.on('click touchstart', '.dropdown-toggle', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $parent = $(this).closest('li');
      const $submenu = $parent.children('.submenu');

      const $openSiblings = $parent.siblings('li.open');

      if ($openSiblings.length) {
        $openSiblings
          .removeClass('open')
          .children('.submenu')
          .stop(true, true)
          .slideUp(250);
      }

      $parent.toggleClass('open');
      $submenu.stop(true, true).slideToggle(250);
    });

    $burgerBtn.on('click', function () {
      $('html, body').toggleClass('menu-open');
    });
  }
});
